enum DineInOrToGo {
  dineIn = 1,
  toGo
}

export default DineInOrToGo
